import { render } from "./OrganizationCreate.vue?vue&type=template&id=723e6233"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/OrganizationCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "723e6233"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('723e6233', __exports__)) {
    api.reload('723e6233', __exports__)
  }
  
  module.hot.accept("./OrganizationCreate.vue?vue&type=template&id=723e6233", () => {
    api.rerender('723e6233', render)
  })

}


export default __exports__